import { ReactNode } from 'react'

import {
	Box,
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	Stack,
	SxProps,
	Theme,
} from '@mui/material'
import { DialogProps } from '@toolpad/core/useDialogs'

import DialogTitle from '../mui/DialogTitle'

// FIXME (rl) this should provide a confirmOnEnter prop
type ConfirmDialogPayload = {
	title: string
	description: string
	content?: ReactNode
	confirmLabel: string
	rejectLabel: string
	sx?: SxProps<Theme>
}

export default function ConfirmDialog({
	payload,
	open,
	onClose,
}: DialogProps<ConfirmDialogPayload, boolean>) {
	return (
		<Dialog open={open} sx={payload.sx}>
			<DialogTitle onClose={() => onClose(false)}>{payload.title}</DialogTitle>
			<DialogContent dividers>
				<Stack>
					{payload.content && <Box my={2}>{payload.content}</Box>}
					{payload.description}
				</Stack>
			</DialogContent>
			<DialogActions>
				<Button variant="outlined" color="error" onClick={() => onClose(false)}>
					{payload.rejectLabel}
				</Button>
				<Button variant="contained" onClick={() => onClose(true)}>
					{payload.confirmLabel}
				</Button>
			</DialogActions>
		</Dialog>
	)
}
